/**
 * return k-text-[size]
 * @param size
 */
export default (size?: string) => {
  if(!size) {
    return ''
  }
  return ['k-text', size].join('-')
}
